import axios from 'axios';

// API URL for kemlo.in domain
const API_URL = process.env.NODE_ENV === 'production' 
    ? 'https://kemlo.in/backend/api'  // Your live domain
    : 'http://localhost:8000/api';    // Local development

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getProducts = async (filters = {}) => {
  try {
    const params = new URLSearchParams(filters).toString();
    const response = await api.get(`/products.php?${params}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

export const getProduct = async (id) => {
  try {
    const response = await api.get(`/products.php?id=${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching product:', error);
    throw error;
  }
};

export const getCategories = async () => {
  try {
    const response = await api.get('/get-categories.php');
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

export const addProduct = async (productData, adminKey) => {
  const formData = new FormData();
  
  // Append all product data to FormData
  Object.keys(productData).forEach(key => {
    if (productData[key] !== null && productData[key] !== undefined) {
      formData.append(key, productData[key]);
    }
  });

  try {
    const response = await axios.post(`${API_URL}/add-product.php`, formData, {
      headers: {
        'X-Admin-Key': adminKey,
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error adding product:', error);
    throw error;
  }
};

export const updateProduct = async (id, productData, adminKey) => {
  try {
    const response = await axios.post(`${API_URL}/update-product.php`, 
      { id, ...productData }, 
      {
        headers: {
          'X-Admin-Key': adminKey,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating product:', error);
    throw error;
  }
};

export const deleteProduct = async (id, adminKey) => {
  try {
    const response = await axios.delete(`${API_URL}/delete-product.php?id=${id}`, {
      headers: {
        'X-Admin-Key': adminKey,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting product:', error);
    throw error;
  }
};

// For debugging - check if API is reachable
export const testConnection = async () => {
  try {
    const response = await axios.get(`${API_URL}/products.php`);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: error.message };
  }
};